export default "__VITE_ASSET__BY0lQWsQ__"